import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { observeNotification } from 'rxjs/internal/Notification';
import { response } from 'express';
import { error } from 'jquery';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public header = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) {}

  getUser(userObj: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.UserApiEndPoint}/getUserById`,
          userObj,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  updateUser(userObj: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(environment.UserApiEndPoint + `/updateUser`, userObj, this.header)
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  verifyUser(email: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.UserApiEndPoint}/isUserExist`,
          { email },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  changePassword(password: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.UserApiEndPoint}/changePassword`,
          { password },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  updateProfile(formData: FormData): Observable<any> {
    const headers = new HttpHeaders();

    return new Observable((observer: any) => {
      this.http
        .post(`${environment.UserApiEndPoint}/updateProfile`, formData, {
          headers,
        })
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getUserList(userObj: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(`${environment.UserApiEndPoint}/userList`, userObj, this.header)
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  createAdmin(formData: FormData): Observable<any> {
    const headers = new HttpHeaders();

    return new Observable((observer: any) => {
      this.http
        .post(`${environment.UserApiEndPoint}/addUser`, formData, {
          headers,
        })
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  updateAdmin(formData: FormData): Observable<any> {
    const headers = new HttpHeaders();

    return new Observable((observer: any) => {
      this.http
        .post(`${environment.UserApiEndPoint}/editUser`, formData, {
          headers,
        })
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  markDelete(userObj: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(`${environment.UserApiEndPoint}/markDelete`, userObj, this.header)
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  getPaginatedProjects(filter: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.UserApiEndPoint}/getPaginatedProjects`,
          filter,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  deleteProject(projectInfo: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .put(
          `${environment.UserApiEndPoint}/deleteProject`,
          projectInfo,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  addProject(formData: FormData): Observable<any> {
    const headers = new HttpHeaders();

    return new Observable((observer: any) => {
      this.http
        .post(`${environment.UserApiEndPoint}/addProject`, formData, {
          headers,
        })
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getProjectDetails(projectId: any): Observable<any> {
    const headers = new HttpHeaders();

    return new Observable((observer: any) => {
      this.http
        .get(`${environment.UserApiEndPoint}/getProjectDetails/${projectId}`, {
          headers,
        })
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  editProject(formData: FormData): Observable<any> {
    const headers = new HttpHeaders();

    return new Observable((observer: any) => {
      this.http
        .post(`${environment.UserApiEndPoint}/editProject`, formData, {
          headers,
        })
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  addRecentProjectLogs(logInfo: any): Observable<any> {
    const headers = new HttpHeaders();
    return new Observable((observer: any) => {
      this.http
        .post(`${environment.UserApiEndPoint}/addRecentProjectLogs`, logInfo, {
          headers,
        })
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  exportProject(filter: any): Observable<Blob> {
    return this.http.post(
      `${environment.UserApiEndPoint}/exportProject`,
      filter,
      {
        responseType: 'blob',
      }
    );
  }

  createSecqurityToken(userObj: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(`${environment.UserApiEndPoint}/createSecqurityToken`, userObj)
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  getSecqurityToken(userObj: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(`${environment.UserApiEndPoint}/getSecqurityToken`, userObj)
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  checkSecqurityTokenValidation(userObj: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.UserApiEndPoint}/checkSecqurityTokenValidation`,
          userObj,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  geLastAccessed10Projets(): Observable<any> {
    const headers = new HttpHeaders();

    return new Observable((observer: any) => {
      this.http
        .get(`${environment.UserApiEndPoint}/geLastAccessed10Projets`, {
          headers,
        })
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  verifySecurityToken(userObj: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(`${environment.UserApiEndPoint}/verifySecurityToken`, userObj)

        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getActiveProjects(): Observable<any> {
    const headers = new HttpHeaders();

    return new Observable((observer: any) => {
      this.http
        .get(`${environment.UserApiEndPoint}/getActiveProjects`, {
          headers,
        })
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  userChangePassword(credentialInfo: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          environment.UserApiEndPoint + `/userChangePassword`,
          credentialInfo,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  resendUserRegistrationEmail(credentialInfo: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          environment.UserApiEndPoint + `/resendUserRegistrationEmail`,
          credentialInfo,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
}
